import { CreatePdfEngineDefaults } from "../engine/CreatePdfEngineDefaults"
import type { PdfEngine } from "../types/engine/PdfEngine"
import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"

const fail = (e: any = undefined): never => {
  if (e) console.error(e)
  throw new Error("Broken engine - not implemented")
}

/**
 * Creates a broken PdfEngine that throws errors for all operations.
 * Useful for testing error handling and as a placeholder.
 */
export const CreateBrokenEngine = (
  config: Partial<PdfEngineOptions> = {}
): PdfEngine => {
  const options = CreatePdfEngineDefaults(config)

  return {
    config: options,
    SplitPdf: fail,
    RasterizePdf: fail,
    MergePdf: fail,
    ZipFiles: fail,
    PlotPdf: fail,
    CreateRemoteFile: fail,
    GenerateFile: fail,
    RequestContent: fail,
  }
}
